// The reducer limits you to 24 unique entries currently.
const MAX_DATABASE_ENTRIES = 23;

export default {
    // Action perf for FindPeople operation. querySTring == null (owa_1 == false) should be tossed.
    MentionsFindPeople: {
        datapoint: {
            name: 'MentionsFindPeople',
        },
    },

    // Logged when a mention is added during a plugin session (not on load)
    MentionsAdded: {
        datapoint: {
            name: 'MentionsAdded',
        },
    },

    // Logged when getMentionsWrappers is called in preperation for send.
    MentionsTotalSave: {
        datapoint: {
            name: 'MentionsTotalSave',
            customData: (
                totalMentions: number,
                numberAddedViaMentions: number
            ): { [key: string]: string } => {
                return {
                    totalMentions: (totalMentions >= MAX_DATABASE_ENTRIES
                        ? MAX_DATABASE_ENTRIES
                        : totalMentions
                    ).toString(),
                    numberAddedViaMentions: (numberAddedViaMentions >= MAX_DATABASE_ENTRIES
                        ? MAX_DATABASE_ENTRIES
                        : numberAddedViaMentions
                    ).toString(),
                };
            },
        },
    },

    // Logged when getPendingTags is called in preperation for draft save.
    MentionsTotalSend: {
        datapoint: {
            name: 'MentionsTotalSend',
            customData: (totalMentions: number): { [key: string]: string } => {
                return {
                    totalMentions: (totalMentions >= MAX_DATABASE_ENTRIES
                        ? MAX_DATABASE_ENTRIES
                        : totalMentions
                    ).toString(),
                };
            },
        },
    },
};
